import React from 'react'
import { Link } from 'react-router-dom'
export default function Payment() {
  return (
    <div className='pay'>
        <Link to="https://rzp.io/l/PDuFLCivUc"> click me to Payment page..!</Link>
       
        </div>
  )
}
